import React, { useEffect, useState } from "react";
import axios from "axios";

const ProfileInfo = () => {
  const USER_ID = localStorage.getItem("user_id");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  /* =========================
     GET USER BY ID (JSON RAW)
  ========================== */
  const fetchUser = async () => {
    try {
      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_user",
        {
          user_id: USER_ID,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.status) {
        const user = res.data.data;
        setFormData({
          name: user.name || "",
          email: user.email || "",
          mobile: user.mobile || "",
        });
      }
    } catch (error) {
      console.error("Fetch user error:", error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  /* =========================
     INPUT HANDLER
  ========================== */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  /* =========================
     UPDATE USER (JSON RAW)
  ========================== */
  const handleSubmit = async () => {
    try {
      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_user",
        {
          user_id: USER_ID,
          name: formData.name,
          email: formData.email,
          mobile: formData.mobile,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.status) {
        alert("Profile updated successfully");
      } else {
        alert("Update failed");
      }
    } catch (error) {
      console.error("Update user error:", error);
    }
  };

  return (
    <div className="card profile-card border-0">
      <div className="card-body">
        <h5 className="card-title">Profile Information</h5>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Full Name</label>
            <input
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Email</label>
            <input
              className="form-control"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Mobile</label>
            <input
              className="form-control"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>E-mail</label>
            <input
              className="form-control"
              value={formData.email}
              readOnly
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Your Gender</label>
            <input className="form-control" value="Male" readOnly />
          </div>
        </div>

        <button className="button3 mt-2" onClick={handleSubmit}>
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default ProfileInfo;
